import { InjectionToken } from '@angular/core';
import { SiteConfig } from './site-config.interface';

export const SITE_CONFIG = new InjectionToken<SiteConfig>('SITE_CONFIG');
